import styled from 'styled-components'

import Stage1 from '~/shared/assets/images/stage-1.png'
import Stage2 from '~/shared/assets/images/stage-2.png'
import Stage3 from '~/shared/assets/images/stage-3.png'
import Stage4 from '~/shared/assets/images/stage-4.png'
import Stage5 from '~/shared/assets/images/stage-5.png'
import Stage6 from '~/shared/assets/images/stage-6.png'
import theme from '~/shared/styles/theme'

function StagePerformance() {
  return (
    <Wrapper>
      <Title>무대 공연</Title>
      <Desc>
        성우 토크쇼, 미니 콘서트, 밴드 공연, 코스플레이 댄스 등 다양한
        아티스트들과 함께하는 무대 공연! DJ 이벤트, 랜덤 플레이 댄스 등 관객들이
        직접 참여하는 프로그램도 다양하게 준비되어 있습니다.
        <br />
        <br />
        이번 ‘제3회 일러스타 페스’에서는 참관객들의 뜨거운 성원에 힘입어 무대의
        크기를 2배로 확장하고 일본 유명 성우, 애니송 가수들과 함께하는 보다
        본격적인 무대 구성을 준비하고 있습니다.
        <br />
        <br />
        <strong>
          무대를 가득 채울 기업, 단체 등의 멋진 제안을 기다리고 있습니다.
        </strong>
      </Desc>
      <ImageGrid>
        <Image src={Stage1} alt="Stage 1" />
        <Image src={Stage2} alt="Stage 2" />
        <Image src={Stage3} alt="Stage 3" />
        <Image src={Stage4} alt="Stage 4" />
        <Image src={Stage5} alt="Stage 5" />
        <Image src={Stage6} alt="Stage 6" />
      </ImageGrid>
    </Wrapper>
  )
}

export default StagePerformance

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;

  height: auto;
  padding: 36px 24px;

  background-color: white;
  border: 1px solid #c1c3c2;
  border-radius: 12px;
`

const Title = styled.h2`
  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 32px;
  font-weight: 500;
`

const Desc = styled.p`
  font-size: 18px;
  line-height: 1.4;
  color: #313634;

  strong {
    font-family: NanumSquareNeo-Bold, sans-serif;
    font-weight: 500;
  }
`

const ImageGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  & > * {
    margin-bottom: 20px;
  }

  & > *:nth-child(3n + 1) {
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;
  }

  & > *:nth-child(3n) {
    margin-right: 0;
    border-top-right-radius: 12px;
    border-bottom-right-radius: 12px;
  }

  @media ${theme.device.medium} {
    & > * {
      flex: 1 1 calc(50% - 10px);
    }

    & > *:nth-child(2n + 1) {
      border-top-left-radius: 12px;
      border-bottom-left-radius: 12px;
    }

    & > *:nth-child(2n) {
      margin-right: 0;
      border-top-right-radius: 12px;
      border-bottom-right-radius: 12px;
    }
  }

  @media ${theme.device.medium} {
    & > * {
      flex: 1 1 100%;
    }

    & > *:nth-child(1) {
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;
    }

    & > *:nth-last-child(1) {
      border-bottom-right-radius: 12px;
      border-bottom-left-radius: 12px;
    }
  }
`

const Image = styled.img`
  width: calc(33.333% - 20px);
  height: 264px;
  object-fit: cover;
  border-radius: 12px;

  @media ${theme.device.medium} {
    width: 100%;
    height: auto;
  }
`
